import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './Home';
import News1 from './News/1';
import News2 from './News/2';
import News3 from './News/3';
import News4 from './News/4';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<Home/>}></Route>
        <Route path="/news/1" element={<News1/>}></Route>
        <Route path="/news/2" element={<News2/>}></Route>
        <Route path="/news/3" element={<News3/>}></Route>
        <Route path="/news/4" element={<News4/>}></Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
